import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {InputItem, TextItem} from '../../models';
import {OpenEndedQuestionEditStore} from '../OpenEndedQuestionEditStore';

function renderItem(item: InputItem | TextItem, key: string | number) {
  if (item.type === 'text')
    return (<span className="text" key={key}>{item.content}</span>);

  if (item.type === 'input')
    return (<input type="text"
                   className="input" key={key}
                   defaultValue="input"/>);

  return null;
}

function* renderer(store: OpenEndedQuestionEditStore): ReactNodeGenerator {
  const model = store.model;
  for (let index = 0; index < model.paragraphs.length; index++) {
    let paragraph = model.paragraphs[index];

    yield (
      <div className="paragraph" key={index}>
        {
          paragraph.items.map(
            (item, index) => renderItem(item, index))
        }
      </div>);
  }

  if (store.countInputs === 0)
    yield (
      <div className="alert alert-info" key="no-inputs">No inputs</div>
    );
}

@observer
export class OpenEndedQuestionPreview extends React.Component<{ store: OpenEndedQuestionEditStore }> {
  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="select-question-preview">
            {Array.from(renderer(this.props.store))}
          </div>
        </div>
      </div>
    );
  }
}
